/* eslint-disable simple-import-sort/sort */

import classnames from 'classnames'
import LandingPageMessageView from 'components/LandingPageMessageView'
import ThemeStyleSheets from 'components/ThemeStyleSheets'
import useInitializeI18n from 'hooks/useInitializeI18n'
import useLanguageSwitcher from 'hooks/useLanguageSwitcher'
import { getFirstGradientLandingPageColor, getSecondGradientLandingPageColor } from 'modules/embed/selectors'
import { getGdprConsentStatus } from 'modules/session/selectors'
import React from 'react'
import { LiveAnnouncer } from 'react-aria-live'
import { useSelector } from 'react-redux'
import GDPR from 'components/GDPR'

import './style.css'

const LandingPageLayout = () => {
  useLanguageSwitcher()

  const { hasConsent: hasGdprConsent } = useSelector(getGdprConsentStatus)

  const firstColorGradient = useSelector(getFirstGradientLandingPageColor)
  const secondColorGradient = useSelector(getSecondGradientLandingPageColor)

  const backgroundGradient = {
    'backgroundImage': `linear-gradient(135deg, #${firstColorGradient}, #${secondColorGradient})`,
    'backgroundSize:': 'cover',
    'backgroundPosition': 'center',
    'backgroundAttachment': 'fixed',
  }

  return (
    <main
      className="drift-widget-landingpage-layout"
      role="main"
      aria-label="Drift Widget messenger"
    >
      <ThemeStyleSheets />
      <div
        className={classnames('drift-widget-landingpage-wrapper', {
          'drift-widget-landingpage-wrapper__open': true,
          'drift-widget-landingpage-wrapper__active-conversation': true
        })}
        style={backgroundGradient}
      >
        { hasGdprConsent && <LandingPageMessageView/> }
        { !hasGdprConsent &&
          <div className="drift-widget-landing-page--gdpr">
            <GDPR previewRef={null} resetChatHeight={() => {}} canRetryConsent={true}/>
          </div>
        }
      </div>
    </main>
  )
}

export default <P extends object>(props: P) => {
  const is18nInitialized = useInitializeI18n()

  return (
    <LiveAnnouncer>
      { is18nInitialized
        ? <LandingPageLayout {...props} />
        : null
      }
    </LiveAnnouncer>
  )
}
